import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTranslation } from "react-i18next";
const IndicatorePagina = ({ dp }) => {
  const location = window.location.href;
  const [pagina, setPagina] = useState("");
  const matches = useMediaQuery("(min-width:600px)");
  const { t } = useTranslation();
  const handleDipartimentoPagina = (pag) => {
    switch (pag) {
      case "chir":
        setPagina("il Dipartimento di Chirurgia");
        break;
      case "med":
        setPagina("il Dipartimento di Medicina");
        break;
      case "matinf":
        setPagina("il Dipartimento Materno-Infantile");
        break;
      case "ds":
        setPagina("il Day Surgery");
        break;
      case "riab":
        setPagina("il Dipartimento di Medicina - Riabilitazione Estensiva");
        break;
      default:
        setPagina(pag);
        break;
    }
  };

  useEffect(() => {
    handleDipartimentoPagina(dp);
  }, [dp]);
  return (
    <>
      {dp && (
        <div style={{ marginTop: "1rem" }}>
          <Typography variant="overline" component="h2">
            {t("Sta compilando il questionario per")}{" "}
            <b>
              {!location.includes("deg") ? t("options." + pagina) : t(pagina)}
            </b>
          </Typography>
        </div>
      )}
    </>
  );
};

export default IndicatorePagina;
